import { Box, CardContent, CardHeader, Stack, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

import Icon from 'components/Icon'
import theme from 'theme'

export const WhatAreGoldenSignals: React.FC = () => {
  return (
    <Box data-testid="what-are-golden-signals">
      <CardHeader
        title={
          <Typography variant="h6">
            What are the Golden Signals?{' '}
            <Link
              target="_blank"
              to={{
                pathname: 'https://www.gremlin.com/blog/four-golden-signals/'
              }}
            >
              <Icon
                css={{ fontSize: theme.fontSizes[2] }}
                icon="arrowUpRightFromSquare"
              />
            </Link>
          </Typography>
        }
      />
      <CardContent>
        <Stack>
          <Stack direction="row" spacing={1}>
            <Typography variant="body2">1.</Typography>
            <Typography variant="body2">
              <b>Latency</b> is the amount of time it takes to serve a request.
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Typography variant="body2">2.</Typography>
            <Typography variant="body2">
              <b>Traffic</b> is the volume of requests that a system is
              currently handling.
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Typography variant="body2">3.</Typography>
            <Typography variant="body2">
              <b>Error rate</b> is the number of requests that fail or return an
              unexpected response.
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Typography variant="body2">4.</Typography>
            <Typography variant="body2">
              <b>Resource saturation</b> is the percentage of available
              resources being consumed.
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Box>
  )
}
